<template>
    <v-container v-if="loading" fill-height>
        <v-layout row align-center justify-center fill-height>
            <v-flex shrink>
                <v-progress-circular indeterminate></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-container>
    <v-container v-else class="pa-2 flex-row fullWidth fullHeight" fluid>
        <v-alert :value="error != null" type="error">
            <span>{{ error }}</span>
        </v-alert>
        <v-card v-if="error == null" class="flex-grow-1 d-flex flex-column fullWidth fullHeight">
            <v-toolbar card color="primary subheading" dark height="64" class="flex-grow-0 d-flex" >
                <v-layout row align-start justify-right>
                    <v-flex grow align-self-center>
                        <span class="title">Daily Harvest Plan</span>
                    </v-flex>
                    <v-flex shrink>
                        <HarvestPlanOverviewWeather></HarvestPlanOverviewWeather>
                    </v-flex>
                    <v-flex shrink align-self-center>
                        <v-btn flat block @click="hideControl = !hideControl">
                            {{hideControl ? 'Show': 'Hide'}} Control
                        </v-btn>
                    </v-flex>
                     <v-flex shrink align-self-center>
                        <v-btn flat icon color="white" @click="refresh">
                                <v-icon>refresh</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex shrink align-self-center>
                        <v-btn flat block :disabled="!canRevertHarvestPlan" @click="revertLastChange">
                            Revert Change
                        </v-btn>
                    </v-flex>
                    <v-flex shrink align-self-center>
                        <v-btn flat block @click="printPage">
                            Export
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-toolbar>
            <v-container class="pa-0 flex-grow-1 d-flex flex-column" fluid>
                <v-layout row align-start justify-center class="pt-2 pb-2 flex-grow-0" v-if="!hideControl">
                    <v-flex>
                        <HarvestPlanFilters></HarvestPlanFilters>
                        <!-- Filters -->
                    </v-flex>
                </v-layout>
                <v-layout v-if="loadingHarvestPlan" row align-center justify-center fill-height>
                    <v-flex shrink>
                        <v-progress-circular indeterminate></v-progress-circular>
                    </v-flex>
                </v-layout>
                <v-layout v-if="!loadingHarvestPlan && selectedUOM" column>                   
                        <!-- Main Content -->
                        <v-flex shrink>
                            <HarvestPlanDetail></HarvestPlanDetail>
                        </v-flex>
                        <v-flex shrink>
                            <HarvestPlanTeam ref="harvestPlanTeamRef"></HarvestPlanTeam>
                        </v-flex>
                </v-layout>
                <v-layout v-if="!loadingHarvestPlan && !hasCategories" justify-center row>
                    <v-flex xs12>
                        <v-alert value="true" type="warning">
                            <span>No Teams Rostered on this Date.</span>
                        </v-alert>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>

import { mapActions, mapState, mapGetters } from 'vuex'
import HarvestPlanOverviewWeather from '@/components/harvestPlan/HarvestPlanOverviewWeather.vue'
import HarvestPlanFilters from '@/components/harvestPlan/HarvestPlanFilters.vue'
import HarvestPlanDetail from '@/components/harvestPlan/HarvestPlanDetail.vue'
import HarvestPlanTeam from '@/components/harvestPlan/HarvestPlanTeam.vue'

export default {
    components: {
        HarvestPlanOverviewWeather,
        HarvestPlanFilters,
        HarvestPlanDetail,
        HarvestPlanTeam
    },
    data(){
        return {
            loading: false,
            hideControl: false
        }
    },
    computed: {
        ...mapState("HarvestPlanStore", [
            "loadingHarvestPlan",            
            "error",
            "harvestPlan"
        ]),
        ...mapGetters("HarvestPlanStore", [            
            "selectedUOM",
            "canRevertHarvestPlan"
        ]),
        hasCategories() {
            return this.harvestPlan && this.harvestPlan.HarvestPlanUOMs && this.harvestPlan.HarvestPlanUOMs.length > 0;
        }
    },
    methods: {
        ...mapActions("HarvestPlanStore", [
            "resetState",
            "loadPlants",
            "loadHarvestPlan",
            "revertLastChange"
        ]),
        async init(){
            this.loading = true;
            await Promise.all([ 
                this.resetState(),               
                this.loadPlants()            
            ]);
            this.loading = false;
        },
        async refresh() {
            await this.loadHarvestPlan();
        },
        printPage() {
            if (this.$refs.harvestPlanTeamRef) {
                this.$refs.harvestPlanTeamRef.expandAllPanels();
                setTimeout(() => {
                    window.print();
                }, 500);
            }
        }
    },
    created(){
        this.init();
    }
}
</script>
<style>
    @media print {

    div.hms-banner,
    nav.hms-menu, 
    .v-input.v-input--checkbox,
    .location-drag,
    .locationMoveButtons {
        display: none !important;
    }
    .layout.column, .container  {
        padding: 0 !important
    }

    .harvestPlanTeamTable tbody td {
        font-size: 1em !important
    }

    .v-toolbar__content, .v-expansion-panel__header {
        border-bottom: 4px solid black;
        color: black;
        font-weight: bolder;
    }

    @page {
        size: landscape;
    }
    }
</style>
<style scoped>
.fullWidth {
    width: 100%;
}
.fullHeight {
    height: 100%;
}
.flex-column {
    flex-direction: column!important;
}

.flex-row {
    flex-direction: row!important;
}

.d-flex {
    display: flex!important;
}

.flex-grow-1 {
    flex-grow: 1!important;
}

.flex-grow-0 {
    flex-grow: 0!important;
}
</style>